<template>
  <div class="EscuelasDetalle">
    <div class="md-layout ">
      <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-33 md-size-25 mb24">
        <md-card>
          <md-card-header>
            <div class="md-title">Información general</div>
          </md-card-header>
          <md-list class="md-double-line md-dense">
            <md-list-item>
              <div class="md-list-item-text">
                <span class="upper">{{escuela.nombre_esc}}</span>
                <span>Nombre</span>
              </div>
            </md-list-item>
            <md-divider />
            <md-list-item>
              <div class="md-list-item-text">
                <span class="upper">{{escuela.clave_esc}}</span>
                <span>Clave</span>
              </div>
            </md-list-item>
            <md-divider />
            <md-list-item>
              <div class="md-list-item-text">
                <span class="upper">{{escuela.alias_esc}}</span>
                <span>Alias</span>
              </div>
            </md-list-item>
            <md-divider />
            <md-list-item>
              <div class="md-list-item-text">
                <span class="upper">{{escuela.nivel_esc}}</span>
                <span>Nivel</span>
              </div>
            </md-list-item>
            <md-divider />
            <md-list-item>
              <div class="md-list-item-text">
                <span class="upper">{{escuela.tipo_esc}}</span>
                <span>Tipo</span>
              </div>
            </md-list-item>
            <md-divider />
            <md-list-item>
              <div class="md-list-item-text">
                <span class="upper">{{`${escuela.calle_esc} #${escuela.num_ext_esc}, COLONIA ${escuela.colonia_esc}, CP ${escuela.cp_esc}. ${escuela.nombre_mpio}, ${escuela.nombre_edo}`}}</span>
                <span>Domicilio</span>
              </div>
            </md-list-item>
            <md-divider />
          </md-list>
          <md-card-actions>
            <md-button class="md-icon-button md-dense">
              <md-icon>edit</md-icon>
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-66 md-size-75">
        <md-card-content>
          <md-tabs
            class="md-primary md-elevation-1 mb24"
            md-alignment="fixed"
            md-sync-route
          >
            <md-tab
              id="tab-contacto"
              md-label="Contactos"
              to="contactos"
            />
            <md-tab
              id="tab-alumnos"
              md-label="Alumnos"
              to="alumnos"
            />
            <!-- md-tab id="tab-citas" md-label="Citas" to="citas" /-->
          </md-tabs>
        </md-card-content>
        <vue-page-transition name="zoom">
          <router-view
            @msg="_notify"
            v-bind:escuela.sync="escuela"
          />
        </vue-page-transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EscuelasDetalle",
  methods: {
    _notify(a) {
      this.$emit("msg", a);
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerEscuela() {
      this.$http.get("escuela/" + this.$route.params.idEsc, this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "escuela" in res.body) {
            this.escuela = res.body.escuela;
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    }
  },
  data() {
    return {
      escuela: {
        alias_esc: null,
        calle_esc: null,
        clave_esc: null,
        colonia_esc: null,
        cp_esc: null,
        id: null,
        id_edo_esc: null,
        id_esc: null,
        id_mpio_esc: null,
        lat_esc: null,
        lng_esc: null,
        nivel_esc: null,
        nombre_esc: null,
        num_ext_esc: null,
        tipo_esc: null
      }
    };
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  created() {
    this._obtenerEscuela();
  }
};
</script>
